import React, { useContext, useEffect, useState } from "react";
import { Button, Card, Col, Figure, Form, Modal, Row } from "react-bootstrap";
import { BASE_URL } from "../../../services/path";

const ViewPayment = ({ show, onHide, currentData }) => {
  console.log("currentData", currentData);
  return (
    <Modal
      show={show}
      onHide={() => {
        onHide();
      }}
      centered
    >
      <Modal.Header closeButton className="py-2">
        <Modal.Title className="fw-bold fs-5">Payment Screen Shot</Modal.Title>
      </Modal.Header>
      <Form className="common-modal" noValidate autoComplete="off">
        <Modal.Body className="p-4">
          <Row>
            <Col md={12} className="mb-3">
              <Card className="sponser-cards speaker-box-layout2 position-relative">
                <Figure>
                  <Card.Img
                    variant="top"
                    src={
                      BASE_URL + "/uploads/" + currentData?.paymentScreenshot ||
                      ""
                    }
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src =
                        "https://static.vecteezy.com/system/resources/previews/022/014/063/original/missing-picture-page-for-website-design-or-mobile-app-design-no-image-available-icon-vector.jpg";
                    }}
                    alt="Profile"
                  />
                </Figure>
              </Card>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <Button
            variant="primary"
            type="submit"
            className="bg-orange border-0"
            onClick={() => onHide()}
          >
            Close
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default ViewPayment;
